<template>
  <div role="tablist" id="searchResult">
    <b-card no-body class="mb-1" v-if=" 'tinfo' in result ">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion2 variant="info">Search Result</b-btn>
      </b-card-header>
       <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <div v-if="result['tinfo'].length>0">
          <b-table striped hover :items="result['tinfo']" :fields="gettinfoFields()" caption-top>
            <template slot="table-caption">
              <b>Primary Site: {{result['tinfo'][0]['tumorsite']}}</b>
            </template>
            <template slot="symbol" slot-scope="data">
              <span v-b-tooltip.hover :title="data.item.ensemblID">{{data.value}}</span>
            </template>
            <template slot="logFC" slot-scope="data">
              <span>{{Number(data.value)===0?'':Number(data.value).toFixed(3)}}</span>
            </template>
            <template slot="lfcSE" slot-scope="data">
              <span>{{Number(data.value)===0?'':Number(data.value).toFixed(3)}}</span>
            </template>
            <template slot="stat" slot-scope="data">
              <span>{{Number(data.value)===0?'':Number(data.value).toFixed(3)}}</span>
            </template>
            <template slot="de_pvalue" slot-scope="data">
              <span>{{Number(data.value)===0?'':Number(data.value).toExponential(3)}}</span>
            </template>
            <template slot="de_padj" slot-scope="data">
              <span>{{Number(data.value)===0?'':Number(data.value).toExponential(2)}}</span>
            </template>
            <template slot="CNV_pvalue" slot-scope="data">
              <span>{{Number(data.value)===0?'':Number(data.value).toExponential(3)}}</span>
            </template>
            <template slot="SUR_pvalue" slot-scope="data">
              <span>{{Number(data.value)===0?'':Number(data.value).toExponential(3)}}</span>
            </template>
            <template slot="showMore" slot-scope="row">
              <b-btn
                size="sm"
                @click="desDetails(row)"
                variant="primary"
              >{{ row.detailsShowing ? '-' : '+' }}</b-btn>
            </template>
            <template slot="row-details" slot-scope="row">
              <boxplot :exprData="row.item.Details" v-if=" 'de_pvalue' in row.item "></boxplot>
              <div v-if=" 'SUR_pvalue' in row.item ">
                <hr>
                <KMCurve :surData="row.item.Details"></KMCurve>
              </div>
            </template>
          </b-table>
          <div v-if=" 'caseinfo' in result ">
            <boxplot :exprData="result['caseinfo']"></boxplot>
          </div>
          <div v-if=" 'cli' in result ">
            <hr>
            <KMCurve :surData="result.caseinfo"></KMCurve>
          </div>
        </div>
        <div v-else>There is no thing to show.</div>
      </b-card-body>
       </b-collapse>
    </b-card>
<!--    <b-card no-body class="mb-1" v-if=" 'de' in result ">-->
<!--      <b-card-header header-tag="header" class="p-1" role="tab">-->
<!--        <b-btn block href="#" v-b-toggle.accordion1 variant="info">Differential Expression</b-btn>-->
<!--      </b-card-header>-->
<!--      <b-collapse id="accordion1" accordion="my-accordion" role="tabpanel" visible>-->
<!--        <b-card-body>-->
<!--          <div v-if="result.de.length>0">-->
<!--            <b-table striped hover :items="result['de']"></b-table>-->
<!--            <boxplot :exprData="result['caseinfo']"></boxplot>-->
<!--          </div>-->
<!--          <div v-else>There is no thing to show.</div>-->
<!--        </b-card-body>-->
<!--      </b-collapse>-->
<!--    </b-card>-->
     <b-card no-body class="mb-1" v-if=" 'des' in result ">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion11 variant="info">Differential Expression</b-btn>
      </b-card-header>
      <b-collapse id="accordion11" accordion="my-accordion" role="tabpanel" visible>
        <b-card-body>
          <div v-if="result.des.length>0">
            <b-table striped hover :fields="desFields" :items="result['des']">
              <template slot="symbol" slot-scope="data">
                <span v-b-tooltip.hover :title="data.item.ensemblID">{{data.value}}</span>
              </template>
              <template slot="pvalue" slot-scope="data">{{Number(data.value)}}</template>
              <template slot="padj" slot-scope="data">{{Number(data.value)}}</template>
              <template slot="showMore" slot-scope="row">
                <b-btn
                  size="sm"
                  @click="desDetails(row)"
                  variant="primary"
                >{{ row.detailsShowing ? '-' : '+' }}</b-btn>
              </template>
              <template slot="row-details" slot-scope="row">
                <boxplot :exprData="row.item.Details"></boxplot>
              </template>
            </b-table>
          </div>
          <div v-else>There is no thing to show.</div>
        </b-card-body>
      </b-collapse>
    </b-card>
     <b-card no-body class="mb-1" v-if=" 'gis' in result ">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion12 variant="info">Copy Number Variates</b-btn>
      </b-card-header>
      <b-collapse id="accordion12" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-table striped hover :items="result['gis']" v-if="result['gis'].length>0"></b-table>
          <div v-else>There is nothing to show.</div>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1" v-if=" 'sur' in result ">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion21 variant="info">Survival Analysis</b-btn>
      </b-card-header>
      <b-collapse id="accordion21" accordion="my-accordion" role="tabpanel" visible>
        <b-card-body>
          <span v-if="result['sur'].length<=0">There is nothing to show.</span>
          <div v-else>
            <b-table striped hover :items="result['sur']"></b-table>
            <b-row>
              <b-col>
                <KMCurve :surData="result.caseinfo" v-if=" 'cli' in result && result.cli.length>0"></KMCurve>
              </b-col>
            </b-row>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
     <b-card no-body class="mb-1" v-if=" 'surs' in result ">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion13 variant="info">Survival Analysis</b-btn>
      </b-card-header>
      <b-collapse id="accordion13" accordion="my-accordion" role="tabpanel" visible>
        <b-card-body>
          <span v-if="result['surs'].length<=0">There is no thing to show.</span>
          <div v-else>
            <b-table striped hover :items="result['surs']" :fields="sursFields">
              <template slot="pvalue" slot-scope="data">{{Number(data.value)}}</template>
              <template slot="showMore" slot-scope="row">
                <b-btn
                  size="sm"
                  @click="sursDetails(row)"
                  variant="primary"
                >{{ row.detailsShowing ? '-' : '+' }}</b-btn>
              </template>
              <template slot="row-details" slot-scope="row">
                <KMCurve :surData="row.item.Details"></KMCurve>
              </template>
            </b-table>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
    <!-- 共表达表格 -->
    <b-card no-body class="mb-1" v-if=" 'co' in result">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion3 variant="info">Coexpression Analysis</b-btn>
      </b-card-header>
      <b-collapse id="accordion3" accordion="my-accordion" role="tabpanel" visible>
        <b-card-body>
          <span v-if="result['co'].length<=0">There is no thing to show.</span>
          <div v-else>
            <b-table striped hover :items="decodeco" :fields="cosFields">
              <template
                slot="p_value"
                slot-scope="data"
              >{{Number(data.value)==0?"&lt;2.2E-16":Number(data.value).toExponential(3)}}</template>
              <template slot="cor" slot-scope="data">{{Number(data.value).toFixed(3)}}</template>
            </b-table>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <!-- clip表格 -->
    <b-card no-body class="mb-1" v-if=" 'clip' in result">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion4 variant="info">Clip-Seq data in starbase</b-btn>
      </b-card-header>
      <b-collapse id="accordion4" accordion="my-accordion" role="tabpanel" visible>
        <b-card-body>
          <span v-if=" 'clip' in result && result['clip'].length<=0">There is no thing to show.</span>
          <div v-else>
            <b-table striped hover :items="result['clip']">
              <template
                slot="geneName"
                slot-scope="data"
              ><a :href="'http://starbase.sysu.edu.cn/rbpClipRNA.php?source=mRNA&flag=none&clade=mammal&genome=human&assembly=hg19&RBP='+ result['tinfo'][0]['symbol'] +' &clipNum=1&panNum=0&target=' + data.value" target="_blank">
              {{data.value}}</a></template>
            </b-table>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <!-- <b-card no-body class="mb-1" v-if=" 'coexpr' in result ">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion3 variant="info">Coexpression Analysis</b-btn>
      </b-card-header>
      <b-collapse id="accordion3" accordion="my-accordion" role="tabpanel" visible>
        <b-card-body>
          <span v-if="result['coexpr'].length<=0">There is no thing to show.</span>
          <div v-else>
            <b-table striped hover :items="result['coexpr']">
              <template
                slot="p"
                slot-scope="data"
              >{{Number(data.value)==0?"&lt;2.2E-16":Number(data.value)}}</template>
            </b-table>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>-->
  </div>
</template>

<script>
import KMCurve from './KMCurve'
import boxplot from './BoxPlot'

export default {
  components: {
    KMCurve,
    boxplot
  },
  name: 'searchResult',
  props: ['result', 'selected'],
  data: function () {
    return {
      onlyCollapse: false,
      desFields: ['tumorsite', 'symbol', 'baseMean', {
        key: 'log2FoldChange',
        label: 'logFC',
        sortable: 1
      }, 'pvalue', 'padj', 'showMore'],
      tinfoFields: [],
      sursFields: ['ensemblID', 'symbol', 'tumorsite', 'pvalue', 'showMore'],
      cosFields: ['corelation symbol', 'corelation ensemblID', { key: 'cor', sortable: true }, 'p_value']
    }
  },
  computed: {
    decodeco: function () {
      // console.log(1)
      var tmp = this.result['co'][0]['info'].split('%')
      tmp = tmp.map(d => {
        d = d.split(';')
        return {
          'corelation symbol': d[1],
          'corelation ensemblID': d[0],
          'cor': d[2],
          'p_value': d[3]
        }
      })
      // console.log(tmp)
      return tmp
    }
  },
  mounted () {
    // console.log(this.onlyCollapse = document.getElementsByClassName('collapse').length === 2)
    this.onlyCollapse = document.getElementsByClassName('collapse').length === 2
    // console.log(this.selected)
  },
  methods: {
    desDetails: function (row) {
      // console.log(row.item)
      if (!('Details' in row.item)) {
        this.axios({
          method: 'post',
          url: '/search.php',
          data: { 'rbp': row.item.symbol, 'tumorsite': row.item.tumorsite, 'type': ['de'] }
        }).then(res => {
          row.item.Details = res.data.caseinfo
          row.toggleDetails()
        })
      } else {
        row.toggleDetails()
      }
    },
    sursDetails: function (row) {
      if (row.detailsShowing === false) {
        this.axios({
          method: 'post',
          url: '/search.php',
          data: { 'rbp': row.item.symbol, 'tumorsite': row.item.tumorsite, 'type': ['sur'] }
        }).then(res => {
          row.item.Details = res.data.caseinfo
          row.toggleDetails()
        })
      } else {
        row.toggleDetails()
      }
    },
    gettinfoFields: function () {
      var tmpArr = this.result['tinfo'][0]
      if ('tinfo' in this.result && this.result['tinfo'].length === 1) {
        var t = Object.keys(tmpArr)
        t.splice(1, 1)
        return (t)
      }

      var res = ['symbol']
      // console.log(tmpArr)
      if ('de_pvalue' in tmpArr) {
        res = res.concat(['baseMean', { key: 'logFC', sortable: 1 }, 'lfcSE', 'stat', { key: 'de_pvalue', sortable: 1 }, { key: 'de_padj', sortable: 1 }])
      }
      if ('CNV_pvalue' in tmpArr) {
        res = res.concat(['CNV_pvalue', 'CNV_type'])
      }
      if ('SUR_pvalue' in tmpArr) {
        res = res.concat(['SUR_pvalue'])
      }
      // console.log(res)
      res = res.concat(['showMore'])
      return res
    }
  }
}
</script>

<style scoped>
#searchResult {
  min-width: 1110px;
}
</style>



// WEBPACK FOOTER //
// src/components/searchResult.vue